import { render, staticRenderFns } from "./ModalAuthorizeTransfer.vue?vue&type=template&id=a45c5dda"
import script from "./ModalAuthorizeTransfer.vue?vue&type=script&lang=js"
export * from "./ModalAuthorizeTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports